import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/home/redux/actions';
import Swal from 'sweetalert2';
import showAlert from '../../../common/utils/alert';
import { prepS3Url } from '../../../common/utils/plugin_utils';

export class AssetTab extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.projectId !== this.props.projectId) {
      this.props.actions.loadProjectAssets({
        projectId: nextProps.projectId,
        version: nextProps.version,
      });
    }
    return true;
  }

  handleDelete = (uuid) => {
    const { projectId, version } = this.props;
    const preConfirm = () => {
      this.props.actions.deleteAsset({ projectId, assetId: uuid, version });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!').then(
      (_result) => {
        let tabcontent = document.getElementById('ASSETS');
        tabcontent.classList.add('selected');
      },
    );
  };

  selectImageToUpload = (imageId) => {
    if (this.state.selectedImageId !== imageId) {
      this.setState({
        selectedImageId: imageId,
      });
    }
  };

  showAssets = () => {
    const { assets, iPlugins } = this.props.home;
    const s3Url = prepS3Url(iPlugins, null, true);
    if (assets.length > 0) {
      return (
        <div className="gjs-pn-panel height35 width100 position-relative">
          <div className="row px-3">
            {assets.map((asset) => (
              <div className="col-6 mb-1 asset-delete-list" key={asset.uuid}>
                <img src={`${s3Url}${asset.key}`} className="asset-img img-fluid" />
                <i
                  className="btn-xs wb webconnect-trash-solid"
                  onClick={() => this.handleDelete(asset.uuid)}
                ></i>
              </div>
            ))}
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <Fragment>
        <div className="gjs-pn-panel gjs-pn-devices-c gjs-one-bg gjs-two-color width100 position-relative width100 border-bottom-theme">
          <div className="gjs-pn-buttons">
            <span title="Assets" className="padding-left-20">
              Assets
            </span>
            <span title="Assets" className="gjs-pn-btn">
              &nbsp;
            </span>
            <span title="Add" className="">
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip="Create New Asset"
                data-place="bottom"
                data-effect="solid"
              >
                <i className="wb webconnect-plus"></i>&nbsp;Add
              </a>
            </span>
            <span title="Search Image" className="">
              <a
                className="btn btn-theme-submit btn-xs"
                data-tip="Search"
                data-place="bottom"
                data-effect="solid"
              >
                <i className="wb webconnect-search"></i>&nbsp; Image
              </a>
            </span>
          </div>
        </div>
        {this.showAssets()}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetTab);
